import $ from 'jquery';

const baseClass = 'news-list-view';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class NewsListView {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    const self = this;

    this.$el.on('click', '.page-navigation a', function(e) {
      self.onPaginationClick($(this), event);
    });
  }

  onPaginationClick($element, event) {
    const ajaxUrl = $element.data('link');
    const self = this;

    if (ajaxUrl == null || ajaxUrl.trim() === '') {
      return;
    }

    event.preventDefault();

    $.ajax({
      url: ajaxUrl,
      type: 'GET',
      success: function (result) {
        const $paginationContainer = self.$el.find(' .pagination-container');
        const $result = $(result);

        const pagination = $result.find('.pagination-container');
        const news = $result.find('article');

        self.$el.find('article').remove();

        news.each(function(){
          $(this).insertBefore($paginationContainer);
        })

        $paginationContainer.replaceWith(pagination);
      }
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new NewsListView(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
